import { FC, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Card, CardContent, CardHeader, Grid, Typography } from '@material-ui/core';
import { AddUserIssues } from '../dialogs/issueDetails';

interface IssuesCardProps {
  productId: string;
  setIssuesList: (data: string[]) => void;
}

export const IssuesCard: FC<IssuesCardProps> = (props) => {
  const { productId, setIssuesList } = props;
  const [openSymptomsSelectDialog, setOpenSymptomsSelectDialog] = useState(false);
  const [issues, setIssues] = useState<string[]>([]);

  const setIssuesData = (data) => {
    setIssuesList(data);
    setIssues(data);
  };

  const renderGridItems = (label, valuesArray) => (
    <Grid
      item
      md={12}
      xs={12}
    >
      <Box>
        {valuesArray?.length > 0 ? (
          <ul
            style={{
              paddingInlineStart: '15px',
              listStyleType: 'disc',
              margin: 0
            }}
          >
            {valuesArray?.map((item) => (
              <li
                key={item}
                style={{ margin: '3px 0px' }}
              >
                <Typography
                  color="textSecondary"
                  variant="body2"
                >
                  {item}
                </Typography>
              </li>
            ))}
          </ul>
        ) : (
          <Typography
            color="textSecondary"
            variant="body2"
          >
            No
            {' '}
            {label}
            {' '}
            Added
          </Typography>
        )}
      </Box>
    </Grid>
  );

  const setValidIssues = () => {
    setIssuesList([]);
    setIssues([]);
  };

  useEffect(() => {
    setValidIssues();
  }, [productId]);

  return (
    <>
      <Card
        variant="outlined"
        sx={{ mt: 1, pb: 2 }}
      >
        <CardHeader
          title="Issues"
          action={(
            <>
              <Button
                size="small"
                variant="contained"
                onClick={() => setOpenSymptomsSelectDialog(true)}
              >
                {issues.length > 0 ? 'Update' : 'Add'}
              </Button>
            </>
          )}
        />
        <CardContent>
          <Grid
            container
            pl={1}
            direction="column"
          >
            {
              renderGridItems('Issue', issues)
            }
          </Grid>
          { openSymptomsSelectDialog && (
          <AddUserIssues
            productId={productId}
            open={openSymptomsSelectDialog}
            onClose={() => setOpenSymptomsSelectDialog(false)}
            issuesDetailData={issues}
            setIssuesData={setIssuesData}
          />
          )}
        </CardContent>
      </Card>
    </>
  );
};

IssuesCard.propTypes = {
  productId: PropTypes.string,
  setIssuesList: PropTypes.func,
};
